import * as React from "react";
import { Route, IndexRoute, RouterState, RedirectFunction } from "react-router"

import { Start } from "../Start/Start";
import { Aktor } from "../Aktor/Aktor";
import { Faktura } from "../Faktura/Faktura";
import { Polise } from "../Polise/Polise";
import { Rapport } from "../Rapport/Rapport";
import { AktorTabell } from "../Aktor/AktorTabell";
import { FakturaTabell } from "../Faktura/FakturaTabell";
import { PoliseTabell } from "../Polise/PoliseTabell";
import { IModelLaster, spinnerDelayMs } from "../domene";
import { checkBlur } from "../Component/components";

import { Meny } from "./Meny"
import { appContext } from "./appContext"

function call(callback?: Function) {
    if(callback !== undefined) {
        callback();
    }
}

// ReSharper disable once Class
function onEnter(nextState: RouterState, replace: RedirectFunction, callback?: Function, args?: (args: any[]) => any) {

    // Check any remaining storing
    checkBlur();

    if (appContext.server || !this.component) {
        call(callback);
    }

    const eksternBruker = appContext.harRelasjon(Gf.Dom.Type.AktørrelasjonType.EksternBruker);
    if (eksternBruker && this.component.name !== "Start")
        return;

    // TODO: Avoid having to construct the component in order to get the path
    const component = new this.component({ params: nextState.params });
    const laster = component.laster as IModelLaster;
    if (laster && laster.loadingSince) {
        // Trigger loading
        component.render();
        let count = 0;
        const checkEveryMs = 10;
        const maxTimes = spinnerDelayMs / checkEveryMs;
        const check = () => {
            let done = (++count > maxTimes);
            if(!done) {
                if(!laster.loadingSince()) {
                    // Extra check to see if everything has loaded
                    component.render();
                    done = !laster.loadingSince();
                }
            }
            if(done) {
                // Remove listeners
                laster.removeHandlers();
                call(callback);
            } else {
                appContext.setTimeout(check, checkEveryMs);
            }
        };
        check();
    } else {
        call(callback);
    }
}

export const routes = <Route path="/" component={Meny}>
    <IndexRoute component={Start} onEnter={onEnter} />
    <Route path="Index" component={Start} onEnter={onEnter} />
    <Route path="Passord/:username/:code" component={Start} onEnter={onEnter} />
    <Route path="Aktor" component={AktorTabell} onEnter={onEnter} />
    <Route path="Aktor/:id" component={Aktor} onEnter={onEnter} />
    <Route path="Polise" component={PoliseTabell} onEnter={onEnter} />
    <Route path="Polise/:id" component={Polise} onEnter={onEnter} />
    <Route path="Faktura" component={FakturaTabell} onEnter={onEnter} />
    <Route path="Faktura/:id" component={Faktura} onEnter={onEnter} />
    <Route path="Rapport" component={Rapport} onEnter={onEnter} />
</Route>;




// WEBPACK FOOTER //
// ./Scripts/React/App/routes.tsx